document.addEventListener('DOMContentLoaded', () => {
  const heroSliders = [];
  const heroes = document.querySelectorAll('[data-hero]');
  const slides = document.querySelectorAll('.hero__slide');
  const playButtons = document.querySelectorAll('[data-hero-slide-play]');
  if(slides.length < 2){
    // return;
  }
  let options = {
    slidesPerView: 1,
    autoHeight: true,
    a11y: true,
    loop: slides.length !== 1,
    speed: 900,
    grabCursor: true,
    watchOverflow: true,
    watchSlidesProgress: true,
    //effect: 'fade',
    // fadeEffect: {
    //   crossFade: true
    // },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true
    },
    keyboard: {
      enabled: true,
      onlyInViewport: true
    },
    on: {
      progress: function(swiper) {
        swiper.slides.forEach((slide) => {
          const slideProgress = slide.progress
          const offset = swiper.width * 0.9;
          const translate = slideProgress * offset;
          slide.querySelector(".hero__slide-media-wrap").style.transform =
            "translate3d(" + translate + "px, 0, 0)";          
        }) 
      },
      touchStart: function(swiper, e) {
        swiper.slides.forEach((slide) => {
          slide.style.transition = "";
        })
      },
      setTransition: function(swiper, transition) {
        swiper.slides.forEach((slide) => {
          slide.style.transition = transition + "ms";
          slide.querySelector(".hero__slide-media-wrap").style.transition =
            transition + "ms";          
        })
      }
    }
  };
  for (const [i, slider] of heroes.entries()) {
    const autoplay = parseInt(slider.getAttribute('data-hero-autoplay'))
    if (autoplay) {
      options = {
        ...options,
        autoplay: {
          delay: autoplay
        }
      }
    }
    heroSliders[i] = new Swiper(slider, options);
  }

  playButtons.forEach((btn) => {
    btn.addEventListener('click', () => {
      const slide = btn.closest('.swiper-slide')
      const video = slide.querySelector('video')
      slide.classList.add('video-active')
      video.play()
    })
  })    
})